'use client';

import { Box } from '@terra/ui-styled-system';
import { AiBrowserStreamingFrame } from '@terra/ui-design-system';
import { useSSE } from '../../app/providers/SseProvider';
import type { Tab } from '../../store/layoutStore';

type BrowserStreamTabProps = {
  tab: Tab;
};

export function BrowserStreamTab({ tab }: BrowserStreamTabProps) {
  const { subscribe } = useSSE();

  const tabData = tab.data as {
    streamingId: string;
  };

  return (
    <Box h="full" w="full" overflow="hidden" p={4}>
      <AiBrowserStreamingFrame
        streamingId={tabData.streamingId}
        onSSESubscribe={subscribe}
        standalone
      />
    </Box>
  );
}
